// The public demo: which kind of sample shop this browser tab shows. A link from the website
// (…/?industry=auto) sets it once; the demo bar changes it; a refresh keeps it. It's kept per tab
// (sessionStorage), so a phone shop in one tab and an auto shop in another never trade places, and
// every request says which one it's for (the x-sos-demo-kind header). Outside the demo the server
// ignores the header.

export type DemoKind = 'cellphone' | 'computer' | 'auto' | 'vacuum';

const KEY = 'sos_demo_tab_kind';
const KINDS: DemoKind[] = ['cellphone', 'computer', 'auto', 'vacuum'];

export function isDemoKind(v: unknown): v is DemoKind {
  return typeof v === 'string' && (KINDS as string[]).includes(v);
}

let kind: DemoKind | null = null;

/** The kind of sample shop this tab shows, if it has said one. */
export function demoKind(): DemoKind | null {
  return kind;
}

/** This tab shows another kind of sample shop from now on (the page reloads after). */
export function setDemoKind(next: DemoKind): void {
  kind = next;
  try {
    sessionStorage.setItem(KEY, next);
  } catch {
    // Storage off (a private window): the header still says it until the page reloads.
  }
}

// On load: the website's link wins (and leaves the address bar), then what this tab showed before.
(function start() {
  try {
    const url = new URL(location.href);
    const asked = url.searchParams.get('industry');
    if (isDemoKind(asked)) {
      setDemoKind(asked);
      url.searchParams.delete('industry');
      history.replaceState(history.state, '', `${url.pathname}${url.search}${url.hash || '#/'}`);
      return;
    }
    const kept = sessionStorage.getItem(KEY);
    if (isDemoKind(kept)) kind = kept;
  } catch {
    // No location or storage (tests): no kind.
  }
})();
